import styled from '@emotion/styled';
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { breakpoints, spacing } from '../../../utils/styleguide';
import { useOutsideClick } from '../../../utils/hooks/useOutsideClick';
import IconButton from '../buttons/IconButton';
import AspectRatioBox from '../layout/AspectRatioBox';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  overflow-y: scroll;
`;

export const FullVideo = styled.video`
  object-fit: contain;
  height: 100%;
  width: 100%;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  ${breakpoints.tablet} {
    display: flex;
    position: absolute;
    top: ${spacing[3]}px;
    right: ${spacing[3]}px;
  }
`;

export const AspectRatioWrapper = styled.div<{ aspectRatio: number }>`
  ${({ aspectRatio }) => `
    width: ${aspectRatio * 100 - 10}vh;
  `}
  display: flex;
  align-items: center;
  ${breakpoints.tablet} {
    max-width: 80%;
  }
`;
type Props = {
  aspectRatio?: number;
  onClose: () => void;
  children: React.ReactNode | React.ReactNode[];
};

export default function OverlayMedia({ onClose, aspectRatio = 9 / 16, children }: Props) {
  const boxRef = useRef(null);
  useOutsideClick(boxRef, () => onClose());

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return createPortal(
    <Overlay>
      <CloseButton ariaLabel="close" iconName="x-ol" onClick={() => onClose()} />
      <AspectRatioWrapper aspectRatio={aspectRatio}>
        <AspectRatioBox aspectRatio={aspectRatio} boxRef={boxRef}>
          {children}
        </AspectRatioBox>
      </AspectRatioWrapper>
    </Overlay>,
    document.body,
  );
}
